import {
  readAlert,
  editAlert,
  createAlert,
  deleteAlert,
} from "~/shared/alertAbilities"

export const useAlertPermissions = async () => {
  const canReadAlert = await allows(readAlert)
  const canEditAlert = await allows(editAlert)
  const canCreateAlert = await allows(createAlert)
  const canDeleteAlert = await allows(deleteAlert)

  return { canReadAlert, canEditAlert, canCreateAlert, canDeleteAlert }
}
